import { Activity, ProcessedActivity } from '../components/declarations/Activity';
import { Page, ProcessedPage } from '../components/declarations/Page';
import { toSlug } from '../helpers/tools';
import { finalToInitialItemMap, itemsConfig } from './itemsConfig';
import { objectConfig } from './objectsConfig';

export const shortProjectName = 'velikonoce';
export const year = '2024';
export const projectName = `${shortProjectName}${year}`;
export const projectHeadline = `Velikonoční košík ${year}`;

declare let __PUBLIC_PATH__: string;
declare let iframePlayerHash: string; // global from backend

let activitiesData: ProcessedActivity[] | null = null;
let pagesData: ProcessedPage[] | null = null;

export const config = {
  DEBUG: false,
  AZ_HASH: 'velikonocni-az-kviz',
  FONT_BASE: 'Noto Sans',
  // eslint-disable-next-line no-undef
  DATA_PATH: `${__PUBLIC_PATH__}dat/`,
  // eslint-disable-next-line no-undef
  SPRITES_PATH: `${__PUBLIC_PATH__}spritesheets/`,
  // eslint-disable-next-line no-undef
  IMAGES_PATH: `${__PUBLIC_PATH__}images/`,

  SIZES: {
    //full with parallax
    SCENE_WIDTH: 4800,
    SCENE_HEIGHT: 800,

    //always visible - scale begin
    MIN_WIDTH: 1600,
    MIN_HEIGHT: 800,

    //full size without parallax
    MAX_WIDTH: 1600,
    MAX_HEIGHT: 800,
  },

  LAYER_DIMENSIONS: [
    { x: 4800, y: 800 },
    { x: 4267, y: 800 },
    { x: 4080, y: 800 },
    { x: 3866, y: 800 },
    { x: 3466, y: 800 },
    { x: 2533, y: 800 },
    { x: 1870, y: 800 },
  ],

  INIT_POS_X: 0.21,
  INIT_POS_Y: 0,

  sound: {
    SOUNDS: {
      ambient: {
        // eslint-disable-next-line no-undef
        path: `${__PUBLIC_PATH__}audio/ambient/`,
        globalConfig: {
          volume: 1,
          loop: true,
          canBeMuted: false,
        },
        items: {
          atmo_loop: {
            volume: 0.7,
          },
        },
      },
      music: {
        // eslint-disable-next-line no-undef
        path: `${__PUBLIC_PATH__}audio/music/`,
        globalConfig: {
          volume: 1,
          loop: true,
          canBeMuted: true,
        },
        items: {
          background_music: {
            volume: 1,
          },
        },
      },
    },
    SFX_PATH: `${__PUBLIC_PATH__}audio/sfx/`,
    ITEMS_PATH: `${__PUBLIC_PATH__}audio/items/`,
    OBJECTS_PATH: `${__PUBLIC_PATH__}audio/objects/`,
    LOCAL_STORAGE_MUSIC: `LsMusic-${projectName}`,
    FADE_VOLUME: 0.2, //should be less than music global volume (music.globalConfig.volume)
    ITEM_DELAY: 400,
    GLOBAL_VOLUME: 1,
  },
};

export function processPagesData(pages: Page[]) {
  //its eiter page (url is filled) or old js game when uuid is filled
  let processedPages: ProcessedPage[] = [];
  pages.forEach((page) => {
    processedPages.push({
      ...page,
      linkHash: toSlug(page.title),
      url: page.uuid ? `/flashAppIframe/${page.uuid}?posterEnabled=false&closeButtonEnabled=false` : page.url,
      modalClass: page.uuid ? 'old-game' : 'page',
    });
  });

  pagesData = processedPages;
  console.log('process pages data', pages, pagesData);
}

export const processActivitiesData = (
  activities: Activity[],
  isMobileOrTablet: boolean,
  isAndroid: boolean,
  isIOS: boolean,
) => {
  let processedActivities: ProcessedActivity[] = [];
  activities.forEach((activity) => {
    const processedActivity: ProcessedActivity = {
      positionId: activity.positionId,
      title: activity.title,
      label: activity.label,
      url: activity.uuid
        ? `/flashAppIframe/${activity.uuid}?posterEnabled=false&closeButtonEnabled=false`
        : `https://player.ceskatelevize.cz/?origin=decko&toolbar=false&hash=${iframePlayerHash}&IDEC=${activity.idec}`,
      linkHash: toSlug(activity.title),
      modalClass: activity.uuid ? 'game' : 'video',
      isContest: !!activity.isContest,
      appLink:
        isAndroid && activity.appLinksPlay
          ? activity.appLinksPlay
          : isIOS && activity.appLinksIos
            ? activity.appLinksIos
            : '',
      isActivityOpen: true,
      day: 0,
      unlockString: '',
    };
    if (!processedActivity.appLink && isMobileOrTablet) {
      if (activity.altTitle && activity.altIdec) {
        processedActivity.title = activity.altTitle;
        processedActivity.linkHash = toSlug(activity.altTitle);
        processedActivity.label = 'Přehrát';
        processedActivity.url = `https://player.ceskatelevize.cz/?origin=decko&toolbar=false&hash=${iframePlayerHash}&IDEC=${activity.altIdec}`; //todo func  - DRY
        processedActivity.modalClass = 'video';
        processedActivity.isContest = false;
      }
    }
    processedActivities.push(processedActivity);
  });

  activitiesData = processedActivities;
  console.log('process activities data', activities, activitiesData);
};

const swap = (obj: { [key: string]: any }) =>
  Object.entries(obj).reduce((acc: any, [key, value]) => ((acc[value] = key), acc), {});
const initialIToFinaltemMap = swap(finalToInitialItemMap);

export const getInitialItemId = (finalItemId: string) => finalToInitialItemMap[finalItemId];
export const getFinalItemId = (initialItemId: string) => initialIToFinaltemMap[initialItemId];
export const isInitialItem = (itemId: string) => !finalToInitialItemMap[itemId];

export const getItemActivityData = (itemId: string) => {
  const item_id = getInitialItemId(itemId) || itemId;
  return activitiesData?.find((item) => item['positionId'] === item_id);
  // return find(propEq(item_id, 'positionId'))(activitiesData);
};
export const getPageData = (id: number) => pagesData && pagesData[id];
export const getItemInfo = (itemId: string) => itemsConfig[itemId];
export const getObjectInfo = (objectId: string) => objectConfig[objectId];
export const getPageDataByHash = (hash: string) => pagesData?.find((item) => item['linkHash'] === hash);
export const getActivityDataByHash = (hash: string) => activitiesData?.find((item) => item['linkHash'] === hash);
